let originalLog = console.log;
export function isInStrictModeRerun() {
    if (process.env.NODE_ENV === 'production')
        return false;
    return console.log !== originalLog;
}
export function captureOriginalConsoleLog() {
    originalLog = console.log;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RyaWN0TW9kZS5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJzdHJpY3RNb2RlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUksV0FBVyxHQUFHLE9BQU8sQ0FBQyxHQUFHLENBQUE7QUFFN0IsTUFBTSxVQUFVLG1CQUFtQjtJQUNsQyxJQUFJLE9BQU8sQ0FBQyxHQUFHLENBQUMsUUFBUSxLQUFLLFlBQVk7UUFBRSxPQUFPLEtBQUssQ0FBQTtJQUN2RCxPQUFPLE9BQU8sQ0FBQyxHQUFHLEtBQUssV0FBVyxDQUFBO0FBQ25DLENBQUM7QUFFRCxNQUFNLFVBQVUseUJBQXlCO0lBQ3hDLFdBQVcsR0FBRyxPQUFPLENBQUMsR0FBRyxDQUFBO0FBQzFCLENBQUMifQ==